import { render } from "./GenerarEtiquetas.vue?vue&type=template&id=ce4f0362&scoped=true"
import script from "./GenerarEtiquetas.vue?vue&type=script&lang=js"
export * from "./GenerarEtiquetas.vue?vue&type=script&lang=js"

import "./GenerarEtiquetas.vue?vue&type=style&index=0&id=ce4f0362&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ce4f0362"]])

export default __exports__